import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const VALUES = [{
  title: 'Strategy First',
  text: 'Meaningful growth begins with thoughtful planning. Every engagement starts with a roadmap, not a rate card.'
}, {
  title: 'Local Fluency, Global Standard',
  text: 'Deep on-the-ground intelligence across East and West Africa, with the rigor of international consultancies.'
}, {
  title: 'Partnership',
  text: 'We work as an embedded extension of our clients\u2019 teams, not an outside vendor.'
}, {
  title: 'Excellence',
  text: 'Exceptional quality in every interaction, from a single media pitch to a multi-market launch.'
}, {
  title: 'Integrity',
  text: 'Trust is our most valuable asset — in how we report results, manage budgets, and represent clients.'
}, {
  title: 'Impact',
  text: 'Everything we do should create measurable value: reach, revenue, reputation, or relationships.'
}];
export function Values() {
  return <section className="w-full bg-ivory py-24 md:py-32" data-id="element-139" data-mp="3r5kio624c11h">
      <div className="max-w-7xl mx-auto px-6" data-id="element-140" data-mp="3w215mwxl09cz">
        <SectionHeading eyebrow="Core Values" title="What guides every engagement." align="center" data-id="element-141" data-mp="3w4x3kl9fiy1f" />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-142" data-mp="8ymmepaaf0oj">
          {VALUES.map((v, i) => <motion.div key={v.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.06
        }} className="border-t-2 border-gold pt-5" data-id="element-143" data-mp="dxzk652p5s5w" data-mpi={i}>
              <h3 className="font-serif text-2xl text-navy" data-id="element-144" data-mp="slkjdnwgb78j">{v.title}</h3>
              <p className="mt-2 text-graphite/80 leading-relaxed" data-id="element-145" data-mp="woqqsyvav4gl">{v.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}